import apiClient from './apiClient';
import type {
    ApiResponse,
    PaginatedResponse,
    Diagnosis,
} from '../types/api';

export const diagnosisService = {
    async getAll(perPage = 15): Promise<PaginatedResponse<Diagnosis>> {
        const response = await apiClient.get<PaginatedResponse<Diagnosis>>(`/diagnoses?per_page=${perPage}`);
        return response.data;
    },

    async getById(id: number): Promise<Diagnosis> {
        const response = await apiClient.get<ApiResponse<Diagnosis>>(`/diagnoses/${id}`);
        return response.data.data;
    },

    async search(term: string, limit = 20): Promise<Diagnosis[]> {
        const response = await apiClient.get<ApiResponse<Diagnosis[]>>(
            `/diagnoses/search?term=${encodeURIComponent(term)}&limit=${limit}`
        );
        return response.data.data;
    },

    async getByGroup(group: string): Promise<Diagnosis[]> {
        const response = await apiClient.get<ApiResponse<Diagnosis[]>>(`/diagnoses/group/${encodeURIComponent(group)}`);
        return response.data.data;
    },

    async findByCode(code: string): Promise<Diagnosis> {
        const response = await apiClient.get<ApiResponse<Diagnosis>>(`/diagnoses/code/${encodeURIComponent(code)}`);
        return response.data.data;
    },
};

export default diagnosisService;
